// =============================================================================
// Lulu Forex — Sidebar + Instant Link Dropdown
// Optimized: single style injection, preloaded font, cached DOM, throttled events
// =============================================================================

(function () {
	"use strict";
	if (window.location && window.location.pathname == '/') {
		var _s = document.createElement('style');
		_s.textContent = 'html,body{display:none!important}';
		(document.head || document.documentElement).appendChild(_s);
		window.location.replace('/app/sales-panel');
	}

	// =========================================================================
	// THEME
	// =========================================================================

	var THEME = {
		primary:     '#4eb4d9',
		primary2:    '#2e9dc7',
		primarySoft: '#d6f0f8',
		bg:          '#f5f7fa',
		surface:     '#ffffff',
		border:      '#e4eaf0',
		text:        '#1a2332',
		sub:         '#64748b',
		muted:       '#94a3b8',
		shadow:      '0 1px 4px rgba(0,0,0,0.07), 0 4px 16px rgba(78,180,217,0.06)',
	};

	// =========================================================================
	// DIMENSIONS
	// =========================================================================

	var WIDTH_OPEN      = 220;
	var WIDTH_COLLAPSED = 56;

	// =========================================================================
	// PRE-COMPUTED ICONS (static strings, not functions)
	// =========================================================================

	function _mk(d) {
		return '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + d + '</svg>';
	}

	var ICONS = {
		chart:    _mk('<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>'),
		bar:      _mk('<rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/>'),
		star:     _mk('<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>'),
		building: _mk('<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>'),
		check:    _mk('<polyline points="9 11 12 14 22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>'),
		campaign: _mk('<path d="M4 3v18"/><path d="M4 4h10l-2 4 2 4H4"/>'),
		calendar: _mk('<rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>'),
		employees: _mk('<circle cx="12" cy="8" r="3"/><path d="M5 20a7 7 0 0 1 14 0"/><circle cx="5" cy="10" r="2"/><circle cx="19" cy="10" r="2"/>'),
		data_import: _mk('<rect x="3" y="8" width="18" height="13" rx="1"/><path d="M3 12h18M3 16h18"/><path d="M12 2v6"/><path d="M9 5l3 3 3-3"/>'),
		chat:     _mk('<path d="M21 11.5a8.38 8.38 0 0 1-1 4 8.5 8.5 0 0 1-7.5 4.5 8.38 8.38 0 0 1-4-.9L3 21l1.5-4.3a8.38 8.38 0 0 1-1-4.2 8.5 8.5 0 0 1 8.5-8.5 8.5 8.5 0 0 1 8.5 8.5z"/>'),
		help:     _mk('<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>'),
		profile:  _mk('<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'),
		chevDown: _mk('<polyline points="6 9 12 15 18 9"/>'),
		chevrons: _mk('<polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/>'),
		logout:   _mk('<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>'),
		target: _mk('<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/><line x1="22" y1="2" x2="15" y2="9"/><polyline points="16 2 22 2 22 8"/>'),
	};

	// =========================================================================
	// NAV ITEMS
	// =========================================================================

	var NAV = [
		{ type: 'section', label: 'Dashboards' },
		{ type: 'item', label: 'Dashboard',     icon: ICONS.chart,     route: '/sales-panel', active_match: 'sales-panel' },
		{ type: 'dropdown', label: 'Reports', icon: ICONS.bar, active_match: 'report', children: [
			{ label: 'Master Report', route: 'app/query-report/Master Report' },
			// { label: 'Lead Conversion Report', route: 'app/query-report/Branch%20Wise%20Lead%20Conversion' },
			{ label: 'Escalation Report', route: 'app/query-report/Escalation%20Summary' },
		]},

		{ type: 'section', label: 'CRM' },
		{ type: 'item', label: 'Opportunities',  icon: ICONS.star,      route: '/app/opportunity',  active_match: 'opportunity' },
		// { type: 'item', label: 'Customers',      icon: ICONS.building,  route: '/app/customer',     active_match: 'customer' },
		// { type: 'item', label: 'Campaign',       icon: ICONS.campaign,  route: '/app/campaign',     active_match: 'campaign' },

		// { type: 'section', label: 'Activities' },
		// { type: 'item', label: 'Tasks',          icon: ICONS.check,     route: '/app/task',                           active_match: 'task' },
		// { type: 'item', label: 'Calendar',       icon: ICONS.calendar,  route: 'app/event/view/calendar/default',     active_match: 'event' },

		{ type: 'section', label: 'System' },
		{ type: 'item', label: 'Employees',      icon: ICONS.employees, route: '/app/employee',             active_match: 'employee' },
		// { type: 'item', label: 'Targets',      icon: ICONS.target, route: '/app/sales-target',             active_match: 'sales-target' },
		{ type: 'item', label: 'Chats',          icon: ICONS.chat,      route: '/app/whatsapp-chat-view',   active_match: 'whatsapp-chat-view' },
		// { type: 'item', label: 'Collection Data Import',      icon: ICONS.data_import, route: 'app/collection-data-import',             active_match: 'collection-data-import' },
		// { type: 'item', label: 'Customer Data Import',      icon: ICONS.data_import, route: 'app/customer-data-import',             active_match: 'customer-data-import' },
		// { type: 'item', label: 'Loan Disbursement Import',  icon: ICONS.data_import, route: 'app/loan-disbursement-import',         active_match: 'loan-disbursement-import' },
	];

	var NAV_BOTTOM = [
		// { type: 'item', label: 'Support', icon: ICONS.help,    route: 'https://erp.alfaedge.org', external: true },
		{ type: 'item', label: 'Profile', icon: ICONS.profile, route: '/app/user',                 active_match: 'user' },
		{ type: 'item', label: 'Logout',  icon: ICONS.logout,  route: '',                          action: 'logout' },
	];

	// =========================================================================
	// STATE
	// =========================================================================

	var isOpen = true;

	// =========================================================================
	// PRE-BUILT NAV HTML (computed once, reused)
	// =========================================================================

	function _buildNavHTML(items) {
		var html = '';
		for (var i = 0; i < items.length; i++) {
			var it = items[i];
			if (it.type === 'section') {
				html += '<div class="sb-section">' + it.label + '</div>';
			} else if (it.type === 'dropdown') {
				html += '<div class="sb-dropdown" data-match="' + (it.active_match || '') + '">'
					+ '<div class="sb-item sb-item--dropdown" title="' + it.label + '">'
					+ '<span class="sb-item-icon">' + it.icon + '</span>'
					+ '<span class="sb-item-label">' + it.label + '</span>'
					+ '<span class="sb-dropdown-chevron">' + ICONS.chevDown + '</span>'
					+ '</div>'
					+ '<div class="sb-dropdown-menu">'
					+ '<div class="sb-dropdown-track">';
				for (var j = 0; j < it.children.length; j++) {
					var child = it.children[j];
					html += '<div class="sb-dropdown-item" data-route="' + (child.route || '') + '" title="' + child.label + '">'
						+ '<span class="sb-dropdown-dot"></span>'
						+ '<span class="sb-dropdown-item-label">' + child.label + '</span>'
						+ '</div>';
				}
				html += '</div></div></div>';
			} else {
				var extraClass = it.action === 'logout' ? ' sb-item--logout' : '';
				html += '<div class="sb-item' + extraClass + '"'
					+ ' data-route="'    + (it.route        || '') + '"'
					+ ' data-match="'    + (it.active_match || '') + '"'
					+ ' data-external="' + (it.external     || false) + '"'
					+ ' data-action="'   + (it.action       || '') + '"'
					+ ' title="'         + it.label + '">'
					+ '<span class="sb-item-icon">' + it.icon  + '</span>'
					+ '<span class="sb-item-label">' + it.label + '</span>'
					+ '</div>';
			}
		}
		return html;
	}

	var NAV_HTML        = _buildNavHTML(NAV);
	var NAV_BOTTOM_HTML = _buildNavHTML(NAV_BOTTOM);

	// =========================================================================
	// SINGLE CONSOLIDATED STYLESHEET (font preloaded, not @import)
	// =========================================================================

	var _stylesInjected = false;

	function injectAllStyles() {
		if (_stylesInjected) return;
		_stylesInjected = true;

		// Preload font via <link> instead of render-blocking @import
		var link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap';
		link.media = 'print';
		link.onload = function () { this.media = 'all'; };
		document.head.appendChild(link);

		var css = ''
			// Hide default navbar immediately (prevents flash before page-change fires)
			+ '.navbar { display: none !important; }'

			// btn-primary override (was separate jQuery injection)
			+ '.btn-primary { background-color: #4eb4d9 !important; }'

			// body offset for sidebar
			+ '.page-container {'
			+     'margin-left: ' + WIDTH_OPEN + 'px !important;'
			+     'transition: margin-left 0.28s cubic-bezier(0.4, 0, 0.2, 1) !important;'
			+ '}'
			+ 'body.sb-is-collapsed .page-container {'
			+     'margin-left: ' + WIDTH_COLLAPSED + 'px !important;'
			+ '}'

			// Layout tweaks
			+ "body { font-family: 'DM Sans', 'Segoe UI', sans-serif !important; background: #f5f7fa !important; }"
			+ '.page-head { display: contents; }'
			+ '.form-tabs-list { display: contents; }'
			+ '.form-tabs { padding-top: 6px; padding-left: 6px; margin-bottom: 6px; }'
			+ '.page-head .container { margin-bottom: 4px; margin-top: 4px; max-width: 100%; }'
			+ '.layout-side-section { display: none; }'
			+ '.layout-main-section { padding-bottom: 20px !important; }'
			+ '.form-footer { padding: 8px 24px 32px; border-radius: 12px; background: white; }'
			+ '.scroll-to-top { display: none !important; }'
			+ '.sidebar-toggle-btn { display: none !important; }'
			+ '.title-text { margin-left: 8px !important; }'
			+ '.page-body { max-width: 100% !important; margin: 0 !important; padding-top: 14px !important; background: #f5f7fa; }'

			// Sidebar container
			+ '#crm-sidebar {'
			+     'position: fixed; top: 0; left: 0; height: 100vh;'
			+     'width: ' + WIDTH_OPEN + 'px;'
			+     'background: ' + THEME.surface + ';'
			+     'border-right: 1px solid ' + THEME.border + ';'
			+     'box-shadow: 2px 0 16px rgba(78,180,217,0.08);'
			+     'display: flex; flex-direction: column; z-index: 1040; overflow: hidden;'
			+     "font-family: 'DM Sans', 'Segoe UI', sans-serif;"
			+     'transition: width 0.28s cubic-bezier(0.4, 0, 0.2, 1);'
			+ '}'
			+ '#crm-sidebar.sb-collapsed { width: ' + WIDTH_COLLAPSED + 'px; }'

			// Top bar
			+ '#crm-sidebar .sb-top {'
			+     'display: flex; align-items: center; justify-content: space-between;'
			+     'padding: 14px 10px 14px 14px; border-bottom: 1px solid ' + THEME.border + ';'
			+     'flex-shrink: 0; min-height: 56px;'
			+ '}'
			+ '#crm-sidebar .sb-brand { display: flex; align-items: center; gap: 10px; overflow: hidden; flex: 1; min-width: 0; }'
			+ '#crm-sidebar .sb-brand-icon { width: 22px; height: 22px; border-radius: 7px; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }'
			+ '#crm-sidebar .sb-brand-name { font-size: 15px; font-weight: 800; color: ' + THEME.text + '; letter-spacing: -0.3px; line-height: 1.15; transition: opacity 0.2s ease; }'

			// Toggle button
			+ '#crm-sidebar .sb-toggle {'
			+     'border: none; background: transparent; cursor: pointer; padding: 5px; border-radius: 6px;'
			+     'color: ' + THEME.muted + '; display: flex; align-items: center; justify-content: center; flex-shrink: 0;'
			+     'transition: background 0.15s, color 0.15s, transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);'
			+ '}'
			+ '#crm-sidebar .sb-toggle:hover { background: ' + THEME.bg + '; color: ' + THEME.primary + '; }'
			+ '#crm-sidebar.sb-collapsed .sb-toggle { transform: rotate(180deg); }'

			// Nav area
			+ '#crm-sidebar .sb-nav { flex: 1; overflow-y: auto; overflow-x: hidden; padding: 8px 0; scrollbar-width: thin; scrollbar-color: ' + THEME.border + ' transparent; }'
			+ '#crm-sidebar .sb-nav::-webkit-scrollbar { width: 4px; }'
			+ '#crm-sidebar .sb-nav::-webkit-scrollbar-thumb { background: ' + THEME.border + '; border-radius: 99px; }'

			// Section labels
			+ '#crm-sidebar .sb-section { font-size: 10px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: ' + THEME.muted + '; padding: 16px 16px 4px; white-space: nowrap; overflow: hidden; transition: opacity 0.15s ease, padding 0.2s ease, font-size 0.2s ease; }'
			+ '#crm-sidebar.sb-collapsed .sb-section { font-size: 0; padding: 0; height: 1px; margin: 8px 10px; background: ' + THEME.border + '; }'

			// Nav items
			+ '#crm-sidebar .sb-item { display: flex; align-items: center; gap: 10px; padding: 8px 12px 8px 14px; margin: 1px 6px; border-radius: 8px; cursor: pointer; color: ' + THEME.sub + '; white-space: nowrap; overflow: hidden; position: relative; transition: background 0.15s ease, color 0.15s ease; }'
			+ '#crm-sidebar .sb-item:hover { background: ' + THEME.bg + '; color: ' + THEME.text + '; }'
			+ '#crm-sidebar .sb-item--active { background: ' + THEME.primarySoft + '; color: ' + THEME.primary + '; font-weight: 600; }'
			+ '#crm-sidebar .sb-item--active::before { content: ""; position: absolute; left: 0; top: 25%; height: 50%; width: 3px; border-radius: 0 3px 3px 0; background: ' + THEME.primary + '; }'
			+ '#crm-sidebar .sb-item-icon { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 20px; height: 20px; }'
			+ '#crm-sidebar .sb-item-label { font-size: 13px; font-weight: 500; transition: opacity 0.15s ease; }'
			+ '#crm-sidebar.sb-collapsed .sb-item { padding: 8px 0; justify-content: center; margin: 1px 4px; }'

			// Dropdown nav items
			+ '#crm-sidebar .sb-dropdown { position: relative; }'
			+ '#crm-sidebar .sb-item--dropdown { justify-content: flex-start; }'
			+ '#crm-sidebar .sb-dropdown-chevron { display: flex; align-items: center; margin-left: auto; transition: transform 0.25s cubic-bezier(0.4,0,0.2,1); color: ' + THEME.muted + '; }'
			+ '#crm-sidebar .sb-dropdown-chevron svg { width: 13px; height: 13px; }'
			+ '#crm-sidebar .sb-dropdown.sb-dropdown--open .sb-dropdown-chevron { transform: rotate(180deg); color: ' + THEME.primary + '; }'

			// Menu container
			+ '#crm-sidebar .sb-dropdown-menu { max-height: 0; overflow: hidden; transition: max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.2s ease; opacity: 0; }'
			+ '#crm-sidebar .sb-dropdown.sb-dropdown--open .sb-dropdown-menu { max-height: 400px; opacity: 1; }'

			// Track — vertical connector line
			+ '#crm-sidebar .sb-dropdown-track { position: relative; margin: 4px 0 4px 23px; padding-left: 16px; }'
			+ '#crm-sidebar .sb-dropdown-track::before { content: ""; position: absolute; left: 0; top: 4px; bottom: 4px; width: 1.5px; background: ' + THEME.border + '; border-radius: 1px; }'

			// Dot indicator per item
			+ '#crm-sidebar .sb-dropdown-dot { position: relative; width: 6px; height: 6px; border-radius: 50%; background: ' + THEME.border + '; flex-shrink: 0; transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease; z-index: 1; }'

			// Child items
			+ '#crm-sidebar .sb-dropdown-item { display: flex; align-items: center; gap: 10px; padding: 7px 10px; margin: 1px 6px 1px 0; border-radius: 7px; cursor: pointer; color: ' + THEME.sub + '; font-size: 13px; font-weight: 500; white-space: nowrap; overflow: hidden; transition: background 0.15s ease, color 0.15s ease; }'
			+ '#crm-sidebar .sb-dropdown-item:hover { background: ' + THEME.bg + '; color: ' + THEME.text + '; }'
			+ '#crm-sidebar .sb-dropdown-item:hover .sb-dropdown-dot { background: ' + THEME.muted + '; transform: scale(1.2); }'

			// Active child
			+ '#crm-sidebar .sb-dropdown-item--active { background: ' + THEME.primarySoft + '; color: ' + THEME.primary + '; font-weight: 600; }'
			+ '#crm-sidebar .sb-dropdown-item--active .sb-dropdown-dot { background: ' + THEME.primary + '; transform: scale(1.3); box-shadow: 0 0 0 3px ' + THEME.primarySoft + '; }'

			// Collapsed state
			+ '#crm-sidebar.sb-collapsed .sb-dropdown-chevron { display: none; }'
			+ '#crm-sidebar.sb-collapsed .sb-dropdown-menu { display: none; }'
			+ '#crm-sidebar.sb-collapsed .sb-dropdown-item-label { opacity: 0; width: 0; overflow: hidden; pointer-events: none; }'

			// Tooltip on collapsed
			+ '#crm-sidebar.sb-collapsed .sb-item:hover::after {'
			+     'content: attr(title); position: absolute; left: calc(100% + 10px); top: 50%; transform: translateY(-50%);'
			+     'background: ' + THEME.text + '; color: #fff; font-size: 12px; font-weight: 500; padding: 5px 10px; border-radius: 6px;'
			+     'white-space: nowrap; pointer-events: none; z-index: 2000; box-shadow: ' + THEME.shadow + ';'
			+ '}'

			// Hide labels when collapsed
			+ '#crm-sidebar.sb-collapsed .sb-brand-name,'
			+ '#crm-sidebar.sb-collapsed .sb-item-label,'
			+ '#crm-sidebar.sb-collapsed .sb-user-info { opacity: 0; width: 0; overflow: hidden; pointer-events: none; }'

			// Search bar (admin only)
			+ '#crm-sidebar .sb-search { padding: 6px 10px 2px; flex-shrink: 0; }'
			+ '#crm-sidebar .sb-search-inner { position: relative; display: flex; align-items: center; }'
			+ '#crm-sidebar .sb-search-icon-inner { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); color: ' + THEME.muted + '; pointer-events: none; display: flex; }'
			+ '#crm-sidebar .sb-search-input { width: 100%; background: ' + THEME.bg + '; border: 1px solid ' + THEME.border + '; border-radius: 8px; padding: 6px 10px 6px 30px; font-size: 12px; color: ' + THEME.text + '; font-family: inherit; outline: none; transition: border-color 0.15s, background 0.15s; box-sizing: border-box; }'
			+ '#crm-sidebar .sb-search-input:focus { border-color: ' + THEME.primary + '; background: ' + THEME.surface + '; }'
			+ '#crm-sidebar .sb-search-input::placeholder { color: ' + THEME.muted + '; }'
			+ '#crm-sidebar.sb-collapsed .sb-search { display: none; }'
			// Admin search dropdown (appended to body, positioned via JS)
			+ '.sb-admin-dropdown { position: absolute; z-index: 1060; background: ' + THEME.surface + '; border: 1px solid ' + THEME.border + '; border-radius: 10px; box-shadow: ' + THEME.shadow + '; max-height: 300px; overflow-y: auto; min-width: 200px; padding: 4px 0; scrollbar-width: thin; scrollbar-color: ' + THEME.border + ' transparent; }'
			+ '.sb-admin-dropdown::-webkit-scrollbar { width: 4px; }'
			+ '.sb-admin-dropdown::-webkit-scrollbar-thumb { background: ' + THEME.border + '; border-radius: 99px; }'
			+ '.sb-admin-item { display: flex; align-items: center; justify-content: space-between; padding: 7px 12px; cursor: pointer; gap: 8px; border-radius: 6px; margin: 0 4px; }'
			+ '.sb-admin-item:hover, .sb-admin-item.active { background: ' + THEME.bg + '; }'
			+ '.sb-admin-item-label { font-size: 13px; font-weight: 500; color: ' + THEME.text + '; flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }'
			+ '.sb-admin-item-sub { font-size: 10px; color: ' + THEME.muted + '; white-space: nowrap; background: ' + THEME.bg + '; border: 1px solid ' + THEME.border + '; border-radius: 4px; padding: 1px 5px; flex-shrink: 0; }'
			+ '.sb-admin-highlight { color: ' + THEME.primary + '; font-weight: 700; background: transparent; }'
			+ '.sb-admin-empty { padding: 8px 12px; color: ' + THEME.muted + '; font-size: 13px; }'

			// Footer
			+ '#crm-sidebar .sb-foot { flex-shrink: 0; padding-bottom: 8px; }'
			+ '#crm-sidebar .sb-foot-divider { height: 1px; background: ' + THEME.border + '; margin: 4px 12px 8px; }'
				+ '#crm-sidebar .sb-item--logout { color: #e05252; }'
				+ '#crm-sidebar .sb-item--logout:hover { background: #fef2f2; color: #c0392b; }'

			// User row
			+ '#crm-sidebar .sb-user { display: flex; align-items: center; gap: 10px; padding: 8px 12px 8px 14px; margin: 0 6px 4px; border-radius: 8px; overflow: hidden; cursor: default; transition: background 0.15s; }'
			+ '#crm-sidebar .sb-user:hover { background: ' + THEME.bg + '; }'
			+ '#crm-sidebar.sb-collapsed .sb-user { justify-content: center; padding: 8px 0; margin: 0 4px 4px; }'
			+ '#crm-sidebar .sb-user-avatar { width: 28px; height: 28px; border-radius: 50%; background: linear-gradient(135deg, ' + THEME.primary + ', ' + THEME.primary2 + '); color: #fff; font-size: 11px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }'
			+ '#crm-sidebar .sb-user-info { overflow: hidden; min-width: 0; transition: opacity 0.15s ease; }'
			+ '#crm-sidebar .sb-user-name { font-size: 12px; font-weight: 600; color: ' + THEME.text + '; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }'
			+ '#crm-sidebar .sb-user-email { font-size: 11px; color: ' + THEME.muted + '; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }'

			// Instant Link Dropdown styles
			+ '.instant-link-dropdown { position: absolute; z-index: 1060; background: var(--fg-color, #fff); border: 1px solid var(--border-color, #d1d8dd); border-radius: 10px; box-shadow: var(--shadow-sm, 0 2px 8px rgba(0,0,0,0.08)), 0 4px 16px rgba(0,0,0,0.06); max-height: 320px; overflow-y: auto; overflow-x: hidden; display: none; min-width: 200px; padding: 4px 0; scrollbar-width: thin; margin-top: 2px; }'
			+ '.instant-link-dropdown::-webkit-scrollbar { width: 5px; }'
			+ '.instant-link-dropdown::-webkit-scrollbar-track { background: transparent; }'
			+ '.instant-link-dropdown::-webkit-scrollbar-thumb { background: var(--scroll-bar-color, #d1d8dd); border-radius: 10px; }'
			+ '.instant-link-dropdown.show { display: block; }'
			+ '.instant-link-item { padding: 8px 12px; cursor: pointer; font-size: var(--text-md, 13px); color: var(--text-color, #333); display: flex; align-items: baseline; gap: 10px; line-height: 1.5; transition: background .05s ease; margin: 0 4px; border-radius: var(--border-radius-sm, 4px); }'
			+ '.instant-link-item:hover, .instant-link-item.active { background: var(--fg-hover-color, var(--bg-color, #f4f5f6)); }'
			+ '.instant-link-item .item-value { font-weight: 500; word-break: break-word; }'
			+ '.instant-link-item .item-name { font-size: 11px; color: var(--text-muted, #8d99a6); font-weight: 400; white-space: nowrap; }'
			+ '.instant-link-item .match-highlight { color: var(--text-color, #333); font-weight: 600; background: transparent; }'
			+ '.instant-link-empty { padding: 8px 12px; color: var(--text-muted, #8d99a6); font-size: var(--text-md, 13px); }'
			+ '.instant-link-loading { padding: 16px 12px; color: var(--text-muted, #8d99a6); font-size: var(--text-sm, 12px); text-align: center; display: flex; align-items: center; justify-content: center; gap: 8px; }'
			+ '.instant-link-loading .ild-spinner { width: 14px; height: 14px; border: 2px solid var(--border-color, #d1d8dd); border-top-color: var(--primary, #2490ef); border-radius: 50%; animation: ild-spin .5s linear infinite; }'
			+ '@keyframes ild-spin { to { transform: rotate(360deg); } }'
			+ '.instant-link-separator { height: 1px; background: var(--border-color, #d1d8dd); margin: 4px 8px; }'
			+ '.instant-link-create { padding: 8px 12px; cursor: pointer; font-size: var(--text-md, 13px); color: var(--primary, #2490ef); display: flex; align-items: center; gap: 8px; line-height: 1.5; margin: 0 4px; border-radius: var(--border-radius-sm, 4px); font-weight: 500; }'
			+ '.instant-link-create:hover, .instant-link-create.active { background: var(--fg-hover-color, var(--bg-color, #f4f5f6)); }'
			+ '.instant-link-create svg { width: 14px; height: 14px; stroke: var(--primary, #2490ef); stroke-width: 2; fill: none; }'
			+ '.instant-link-clear-row { padding: 8px 12px; cursor: pointer; font-size: var(--text-md, 13px); color: var(--text-muted, #8d99a6); display: flex; align-items: center; gap: 8px; line-height: 1.5; margin: 0 4px; border-radius: var(--border-radius-sm, 4px); }'
			+ '.instant-link-clear-row:hover, .instant-link-clear-row.active { background: var(--fg-hover-color, var(--bg-color, #f4f5f6)); color: var(--text-color, #333); }'
			+ '.instant-link-clear-row svg { width: 12px; height: 12px; stroke: currentColor; stroke-width: 2; stroke-linecap: round; fill: none; }';

		var el = document.createElement('style');
		el.id = 'crm-sb-styles';
		el.textContent = css;
		document.head.appendChild(el);
	}

	// =========================================================================
	// SIDEBAR — BUILD (once)
	// =========================================================================

	// Cached DOM references
	var _cachedNameEl, _cachedEmailEl, _cachedAvatarEl, _cachedItems;
	var _lastUserFullname = '', _lastUserEmail = '';

	function build_sidebar() {
		if (document.getElementById('crm-sidebar')) return;

		var sb = document.createElement('div');
		sb.id = 'crm-sidebar';
		sb.innerHTML = ''
			+ '<div class="sb-top">'
			+   '<div class="sb-brand">'
			+     '<div class="sb-brand-icon"><img src="/files/lulu-icon-removebg-preview.png" alt="Lulu Money Philippines"></div>'
			+     '<span class="sb-brand-name">Lulu Money<br>Philippines</span>'
			+   '</div>'
			+   '<button class="sb-toggle" id="sb-toggle" title="Toggle sidebar">'
			+     ICONS.chevrons
			+   '</button>'
			+ '</div>'
			+ '<div class="sb-search" id="sb-search-wrap" style="display:none">'
			+   '<div class="sb-search-inner">'
			+     '<span class="sb-search-icon-inner"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg></span>'
			+     '<input type="text" class="sb-search-input" id="sb-search-input" placeholder="Search doctypes &amp; pages..." autocomplete="off">'
			+   '</div>'
			+ '</div>'
			+ '<nav class="sb-nav" id="sb-nav">' + NAV_HTML + '</nav>'
			+ '<div class="sb-foot">'
			+   '<div class="sb-foot-divider"></div>'
			+   '<div class="sb-user" id="sb-user">'
			+     '<div class="sb-user-avatar" id="sb-user-avatar">?</div>'
			+     '<div class="sb-user-info">'
			+       '<div class="sb-user-name" id="sb-user-name"></div>'
			+       '<div class="sb-user-email" id="sb-user-email"></div>'
			+     '</div>'
			+   '</div>'
			+   NAV_BOTTOM_HTML
			+ '</div>';

		document.body.appendChild(sb);

		// Cache DOM refs after append
		_cachedNameEl   = document.getElementById('sb-user-name');
		_cachedEmailEl  = document.getElementById('sb-user-email');
		_cachedAvatarEl = document.getElementById('sb-user-avatar');

		// Toggle button
		document.getElementById('sb-toggle').addEventListener('click', function () {
			isOpen = !isOpen;
			sb.classList.toggle('sb-collapsed', !isOpen);
			document.body.classList.toggle('sb-is-collapsed', !isOpen);
		});

		// Nav click delegation (single listener)
		sb.addEventListener('click', function (e) {
			// Handle dropdown toggle
			var ddToggle = e.target.closest('.sb-item--dropdown');
			if (ddToggle) {
				var dropdown = ddToggle.closest('.sb-dropdown');
				if (dropdown) {
					dropdown.classList.toggle('sb-dropdown--open');
				}
				return;
			}

			// Handle dropdown child item click
			var ddItem = e.target.closest('.sb-dropdown-item');
			if (ddItem) {
				var route = ddItem.dataset.route;
				if (route) {
					frappe.set_route(route.replace(/^\/(app\/)?/, ''));
				}
				return;
			}

			var item = e.target.closest('.sb-item');
			if (!item) return;

			// Close any open dropdowns when clicking a non-dropdown item
			var openDropdowns = sb.querySelectorAll('.sb-dropdown--open');
			for (var i = 0; i < openDropdowns.length; i++) {
				openDropdowns[i].classList.remove('sb-dropdown--open');
			}

			var route = item.dataset.route;
			var match = item.dataset.match;

			if (item.dataset.action === 'logout') {
				frappe.confirm('Are you sure you want to log out?', function () {
					frappe.call({ method: 'logout' }).then(function () {
						window.location.href = '/login';
					});
				});
				return;
			}
			if (match === 'user') {
				route = '/app/user/' + frappe.session.user;
			}
			if (!route) return;
			if (item.dataset.external === 'true') {
				window.open(route, '_blank');
			} else {
				frappe.set_route(route.replace(/^\/(app\/)?/, ''));
			}
		});

		fill_user_info();
		setup_search();
	}

	// =========================================================================
	// ADMIN SEARCH BAR
	// =========================================================================

	function setup_search() {
		var wrap = document.getElementById('sb-search-wrap');
		if (!wrap) return;
		if (!window.frappe || !frappe.session || !frappe.boot) return;

		var roles = (frappe.boot.user && frappe.boot.user.roles) || [];
		var isAdmin = frappe.session.user === 'Administrator' || roles.indexOf('System Manager') !== -1;
		if (!isAdmin) return;

		wrap.style.display = 'block';

		var input = document.getElementById('sb-search-input');
		if (!input || input._searchBound) return;
		input._searchBound = true;

		// Build the flat list of searchable items once from boot data
		var _items = null;
		function getItems() {
			if (_items) return _items;
			_items = [];
			var canRead = (frappe.boot.user && frappe.boot.user.can_read) || [];
			for (var i = 0; i < canRead.length; i++) {
				var dt = canRead[i];
				var isSingle = frappe.boot.single_types && frappe.boot.single_types.indexOf(dt) !== -1;
				_items.push({ label: dt, sub: isSingle ? 'Single' : 'List', action: (function (d, s) { return function () { s ? frappe.set_route('Form', d, d) : frappe.set_route('List', d, 'List'); }; })(dt, isSingle) });
			}
			var pages = frappe.boot.allowed_pages || [];
			for (var j = 0; j < pages.length; j++) {
				var pg = pages[j];
				var pgTitle = (frappe.boot.page_info && frappe.boot.page_info[pg] && frappe.boot.page_info[pg].title) || pg;
				_items.push({ label: pgTitle, sub: 'Page', action: (function (p) { return function () { frappe.set_route('page', p); }; })(pg) });
			}
			return _items;
		}

		function filterItems(txt) {
			var all = getItems();
			if (!txt) return all.slice(0, 20);
			var q = txt.toLowerCase();
			var starts = [], contains = [];
			for (var i = 0; i < all.length; i++) {
				var l = all[i].label.toLowerCase();
				if (l.indexOf(q) === 0) starts.push(all[i]);
				else if (l.indexOf(q) !== -1) contains.push(all[i]);
			}
			return starts.concat(contains).slice(0, 20);
		}

		function escHtml(s) { return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

		function hlText(text, query) {
			if (!query) return text;
			var esc = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			return text.replace(new RegExp('(' + esc + ')', 'gi'), '<span class="sb-admin-highlight">$1</span>');
		}

		// Dropdown DOM element — appended to body so it escapes sidebar overflow
		var drop = document.createElement('div');
		drop.className = 'sb-admin-dropdown';
		drop.style.display = 'none';
		document.body.appendChild(drop);

		var _activeIdx = -1;
		var _filtered  = [];

		function positionDrop() {
			var r = input.getBoundingClientRect();
			drop.style.top    = (r.bottom + window.scrollY + 4) + 'px';
			drop.style.left   = (r.left + window.scrollX) + 'px';
			drop.style.width  = r.width + 'px';
		}

		function renderDrop(items, txt) {
			_filtered  = items;
			_activeIdx = -1;
			if (!items.length) {
				drop.innerHTML = '<div class="sb-admin-empty">No results</div>';
			} else {
				var html = '';
				for (var i = 0; i < items.length; i++) {
					var escaped = escHtml(items[i].label);
					html += '<div class="sb-admin-item" data-idx="' + i + '">'
						+ '<span class="sb-admin-item-label">' + hlText(escaped, txt ? escHtml(txt) : '') + '</span>'
						+ '<span class="sb-admin-item-sub">' + escHtml(items[i].sub) + '</span>'
						+ '</div>';
				}
				drop.innerHTML = html;
			}
			positionDrop();
			drop.style.display = 'block';
		}

		function hideDrop() {
			drop.style.display = 'none';
			_activeIdx = -1;
		}

		function moveActive(dir) {
			var els = drop.querySelectorAll('.sb-admin-item');
			if (!els.length) return;
			if (_activeIdx >= 0) els[_activeIdx].classList.remove('active');
			_activeIdx += dir;
			if (_activeIdx < 0) _activeIdx = els.length - 1;
			if (_activeIdx >= els.length) _activeIdx = 0;
			els[_activeIdx].classList.add('active');
			els[_activeIdx].scrollIntoView({ block: 'nearest' });
		}

		function selectCurrent() {
			if (_activeIdx >= 0 && _filtered[_activeIdx]) {
				_filtered[_activeIdx].action();
				input.value = '';
				hideDrop();
				input.blur();
			}
		}

		input.addEventListener('focus', function () {
			renderDrop(filterItems(input.value), input.value);
		});
		input.addEventListener('input', function () {
			renderDrop(filterItems(input.value), input.value);
		});
		input.addEventListener('keydown', function (e) {
			if (drop.style.display === 'none') return;
			if (e.key === 'ArrowDown') { e.preventDefault(); moveActive(1); }
			else if (e.key === 'ArrowUp')   { e.preventDefault(); moveActive(-1); }
			else if (e.key === 'Enter')     { e.preventDefault(); selectCurrent(); }
			else if (e.key === 'Escape')    { hideDrop(); input.blur(); }
			else if (e.key === 'Tab')       { hideDrop(); }
		});
		input.addEventListener('blur', function () {
			// Small delay so mousedown on a dropdown item fires first
			setTimeout(function () { hideDrop(); }, 160);
		});

		drop.addEventListener('mousedown', function (e) {
			var item = e.target.closest('.sb-admin-item');
			if (item) {
				var idx = parseInt(item.getAttribute('data-idx'), 10);
				if (_filtered[idx]) {
					_filtered[idx].action();
					input.value = '';
					hideDrop();
				}
			}
			e.preventDefault();
		});

		window.addEventListener('scroll', function () { if (drop.style.display !== 'none') positionDrop(); }, true);
		window.addEventListener('resize', function () { if (drop.style.display !== 'none') positionDrop(); });

		// Ctrl+K shortcut to focus the sidebar search
		document.addEventListener('keydown', function (e) {
			if ((e.ctrlKey || e.metaKey) && e.key === 'k') {
				e.preventDefault();
				e.stopPropagation();
				input.focus();
			}
		});
	}

	// =========================================================================
	// ACTIVE HIGHLIGHT — with cached querySelectorAll
	// =========================================================================

	function highlight_active() {
		// Refresh user info only if changed
		fill_user_info();
		setup_search();

		var path = decodeURIComponent(window.location.pathname + window.location.hash);

		// Re-query items only if not cached or sidebar was rebuilt
		if (!_cachedItems || !_cachedItems.length) {
			_cachedItems = document.querySelectorAll('#crm-sidebar .sb-item');
		}

		for (var i = 0; i < _cachedItems.length; i++) {
			var match = _cachedItems[i].dataset.match;
			var isMatch = false;
			if (match) {
				var idx = path.indexOf(match);
				if (idx !== -1) {
					var afterChar = path[idx + match.length];
					isMatch = !afterChar || afterChar === '/' || afterChar === '?' || afterChar === '#';
				}
			}
			_cachedItems[i].classList.toggle('sb-item--active', isMatch);
		}

		// Highlight active dropdown items and auto-open parent dropdown
		var ddItems = document.querySelectorAll('#crm-sidebar .sb-dropdown-item');
		for (var j = 0; j < ddItems.length; j++) {
			var route = ddItems[j].dataset.route || '';
			var cleanRoute = route ? route.replace(/^\/(app\/)?/, '') : '';
			var rIdx = cleanRoute ? path.indexOf(cleanRoute) : -1;
			var rAfter = rIdx !== -1 ? path[rIdx + cleanRoute.length] : null;
			var isActive = rIdx !== -1 && (!rAfter || rAfter === '/' || rAfter === '?' || rAfter === '#');
			ddItems[j].classList.toggle('sb-dropdown-item--active', isActive);
			if (isActive) {
				var parentDD = ddItems[j].closest('.sb-dropdown');
				if (parentDD) parentDD.classList.add('sb-dropdown--open');
			}
		}

		// Also highlight the dropdown parent if any child route matches
		var dropdowns = document.querySelectorAll('#crm-sidebar .sb-dropdown');
		for (var k = 0; k < dropdowns.length; k++) {
			var ddMatch = dropdowns[k].dataset.match;
			var ddParent = dropdowns[k].querySelector('.sb-item--dropdown');
			if (ddParent) {
				var ddIdx = ddMatch ? path.indexOf(ddMatch) : -1;
				var ddAfter = ddIdx !== -1 ? path[ddIdx + ddMatch.length] : null;
				var ddIsMatch = ddIdx !== -1 && (!ddAfter || ddAfter === '/' || ddAfter === '?' || ddAfter === '#');
				ddParent.classList.toggle('sb-item--active', ddIsMatch);
			}
		}
	}

	// =========================================================================
	// USER INFO — skip DOM writes if unchanged
	// =========================================================================

	function fill_user_info() {
		if (!window.frappe || !frappe.session) return;

		var fullname = frappe.session.user_fullname || frappe.session.user || '';
		var email    = frappe.session.user_email    || frappe.session.user || '';

		// Skip if nothing changed
		if (fullname === _lastUserFullname && email === _lastUserEmail) return;
		_lastUserFullname = fullname;
		_lastUserEmail    = email;

		var initials = fullname.split(' ')
			.map(function (n) { return n[0]; })
			.join('').toUpperCase().slice(0, 2);

		if (_cachedNameEl)   _cachedNameEl.textContent   = fullname;
		if (_cachedEmailEl)  _cachedEmailEl.textContent  = email;
		if (_cachedAvatarEl) _cachedAvatarEl.textContent = initials;
	}

	// =========================================================================
	// PAGE-CHANGE HANDLER
	// =========================================================================

	$(document).on('page-change', function () {
		if (!frappe.session.user || frappe.session.user === 'Guest') return;
		injectAllStyles();
		build_sidebar();
		highlight_active();
		// Clean up orphaned link dropdown divs (input no longer in DOM)
		$('.instant-link-dropdown').each(function () {
			var $dd = $(this);
			if (!$dd.data('ild-input') || !$.contains(document, $dd.data('ild-input')[0])) {
				$dd.remove();
			}
		});
	});

	// =========================================================================
	// INSTANT LINK DROPDOWN
	// =========================================================================

	if (!frappe) return;

	var CACHE_TTL_MS    = 10 * 60 * 1000;
	var PREFETCH_LIMIT  = 100;
	var MAX_SHOW        = 20;

	// Store
	var _store = {};
	var _inFlight = {};

	function storeGet(dt) {
		var e = _store[dt];
		if (!e) return null;
		if (Date.now() - e.ts > CACHE_TTL_MS) { delete _store[dt]; return null; }
		return e.data;
	}

	function storeSet(dt, data) {
		_store[dt] = { data: data, ts: Date.now() };
	}

	// Fetch — use XHR with abort support for stale requests
	function fetchLink(doctype, txt, limit, abortController, filters, query) {
		return new Promise(function (resolve) {
			var xhr = new XMLHttpRequest();
			if (abortController) {
				abortController.xhr = xhr;
			}
			var cmd = query || 'frappe.desk.search.search_link';
			xhr.open('POST', '/api/method/' + cmd, true);
			xhr.setRequestHeader('Content-Type', 'application/json');
			xhr.setRequestHeader('Accept', 'application/json');
			xhr.setRequestHeader('X-Frappe-CSRF-Token', frappe.csrf_token);
			xhr.onreadystatechange = function () {
				if (xhr.readyState !== 4) return;
				if (xhr.status === 200) {
					try {
						var r = JSON.parse(xhr.responseText);
						resolve(r.message || r.results || []);
					} catch (e) { resolve([]); }
				} else { resolve([]); }
			};
			var payload = {
				cmd: cmd,
				doctype: doctype,
				txt: txt || '',
				page_length: limit || PREFETCH_LIMIT,
			};
			if (filters && Object.keys(filters).length) {
				payload.filters = JSON.stringify(filters);
			}
			xhr.send(JSON.stringify(payload));
		});
	}

	function prefetch(dt, filters, query) {
		var key = dt;
		if (filters || query) key = dt + '::' + JSON.stringify({ filters: filters, query: query });
		if (storeGet(key)) return Promise.resolve(storeGet(key));
		if (_inFlight[key]) return _inFlight[key];
		_inFlight[key] = fetchLink(dt, '', PREFETCH_LIMIT, null, filters, query).then(function (results) {
			delete _inFlight[key];
			storeSet(key, results);
			return results;
		});
		return _inFlight[key];
	}

	// Client-side filter — searches value, label, and description
	function filterResults(results, txt) {
		if (!txt) return results.slice(0, MAX_SHOW);
		var q = txt.toLowerCase();
		var starts = [], contains = [], labelStarts = [], labelContains = [];
		for (var i = 0; i < results.length; i++) {
			var v = (results[i].value || '').toLowerCase();
			var l = (results[i].label || results[i].description || '').toLowerCase();
			if (v.indexOf(q) === 0) starts.push(results[i]);
			else if (l.indexOf(q) === 0) labelStarts.push(results[i]);
			else if (v.indexOf(q) > -1) contains.push(results[i]);
			else if (l.indexOf(q) > -1) labelContains.push(results[i]);
		}
		return starts.concat(labelStarts, contains, labelContains).slice(0, MAX_SHOW);
	}

	function isTitleLink(dt) {
		return dt && (frappe.boot.link_title_doctypes || []).indexOf(dt) !== -1;
	}

	// Throttle utility for scroll/resize
	function throttle(fn, ms) {
		var last = 0, timer = null;
		return function () {
			var now = Date.now();
			if (now - last >= ms) {
				last = now;
				fn();
			} else if (!timer) {
				timer = setTimeout(function () {
					last = Date.now();
					timer = null;
					fn();
				}, ms - (now - last));
			}
		};
	}

	// -------------------------------------------------------
	// Dropdown class
	// -------------------------------------------------------
	function LinkDropdown($input, control) {
		this.$input = $input;
		this.control = control;
		this.activeIndex = -1;
		this.items = [];
		this._serverTimer = null;
		this._visible = false;
		this._mouseDownOnDropdown = false;

		this.$el = $('<div class="instant-link-dropdown"></div>');
		this.$el.data('ild-input', $input);
		$(document.body).append(this.$el);

		this._bindEvents();
	}

	LinkDropdown.prototype = {
		_bindEvents: function () {
			var me = this;

			this.$input.on('focus.ild', function () { me._onFocus(); });
			this.$input.on('input.ild', function () { me._onInput(); });
			this.$input.on('keydown.ild', function (e) { me._onKeydown(e); });

			this.$el.on('mousedown pointerdown', function (e) {
				e.stopPropagation();
				me._mouseDownOnDropdown = true;
			});

			this.$el.on('mousedown', '.instant-link-item', function (e) {
				e.preventDefault();
				me._select($(this).attr('data-value'));
			});

			this.$el.on('mousedown', '.instant-link-create', function (e) {
				e.preventDefault();
				var dt = $(this).attr('data-doctype');
				me.hide();
				if (dt) me._createNew(dt);
			});

			this.$el.on('mousedown', '.instant-link-clear-row', function (e) {
				e.preventDefault();
				me._clearValue();
			});

			this.$input.on('blur.ild', function () {
				if (me._mouseDownOnDropdown) {
					me._mouseDownOnDropdown = false;
					me.$input.focus();
					return;
				}
				// Reset selected flag (mirrors Frappe's pattern)
				if (me.control) me.control.selected = false;
				me.hide();
			});

			$(document).on('mousedown.ild_' + this._uid(), function (e) {
				if (!me._visible) return;
				if ($(e.target).closest(me.$el).length) return;
				if ($(e.target).closest(me.$input).length) return;
				me.hide();
			});

			// Throttled reposition on scroll/resize (16ms ≈ 60fps)
			var reposition = throttle(function () { if (me._visible) me._position(); }, 16);
			$(window).on('scroll.ild_' + this._uid(), reposition);
			$(window).on('resize.ild_' + this._uid(), reposition);
		},

		_uid: function () {
			if (!this.__uid) this.__uid = Math.random().toString(36).substr(2, 8);
			return this.__uid;
		},

		_onFocus: function () {
			if (this._justSelected) return;
			var dt = this._getDoctype();
			if (!dt) return;

			var key = this._cacheKey();
			var args = this._getQueryArgs();
			var cached = storeGet(key);
			if (cached) {
				this._showResults(cached, this.$input.val());
			} else {
				this._showLoading();
				var me = this;
				var loadStart = Date.now();
				fetchLink(dt, '', PREFETCH_LIMIT, null, args.filters, args.query).then(function (results) {
					if (!me.$input.is(':focus')) return;
					storeSet(key, results);
					var remaining = Math.max(0, 350 - (Date.now() - loadStart));
					setTimeout(function () {
						if (me.$input.is(':focus') && results) {
							me._showResults(results, me.$input.val());
						}
					}, remaining);
				});
			}
		},

		_onInput: function () {
			var dt = this._getDoctype();
			if (!dt) return;

			var txt = this.$input.val() || '';
			var key = this._cacheKey();
			var cached = storeGet(key);

			if (cached) {
				var filtered = filterResults(cached, txt);
				this._renderItems(filtered, txt);
				this.show();
				if (txt.length >= 3 && filtered.length < 3) {
					this._serverSearch(dt, txt);
				}
			} else {
				this._showLoading();
				this._serverSearch(dt, txt);
			}
		},

		_onKeydown: function (e) {
			if (!this._visible) return;

			switch (e.key) {
				case 'ArrowDown':
					e.preventDefault();
					this._moveActive(1);
					break;
				case 'ArrowUp':
					e.preventDefault();
					this._moveActive(-1);
					break;
				case 'Enter':
					e.preventDefault();
					var $allItems = this.$el.find('.instant-link-clear-row, .instant-link-item, .instant-link-create');
					var $activeEl = $allItems.eq(this.activeIndex);
					if ($activeEl.hasClass('instant-link-clear-row')) {
						this._clearValue();
					} else if ($activeEl.hasClass('instant-link-create')) {
						var dt = $activeEl.attr('data-doctype');
						this.hide();
						if (dt) this._createNew(dt);
					} else if (this.activeIndex >= 0 && this.items[this.activeIndex]) {
						this._select(this.items[this.activeIndex].value);
					}
					break;
				case 'Escape':
					this.hide();
					this.$input.blur();
					break;
				case 'Tab':
					this.hide();
					break;
			}
		},

		_moveActive: function (dir) {
			var $items = this.$el.find('.instant-link-clear-row, .instant-link-item, .instant-link-create');
			if (!$items.length) return;

			this.activeIndex += dir;
			if (this.activeIndex < 0) this.activeIndex = $items.length - 1;
			if (this.activeIndex >= $items.length) this.activeIndex = 0;

			$items.removeClass('active');
			var $active = $items.eq(this.activeIndex);
			$active.addClass('active');
			if ($active[0]) $active[0].scrollIntoView({ block: 'nearest' });
		},

		_select: function (val) {
			if (!val) return;
			this.hide();
			this._justSelected = true;
			this._mouseDownOnDropdown = false;
			var ctrl = this.control;
			if (!ctrl) return;

			// Prevent Frappe's blur handler from re-validating
			ctrl.selected = true;

			var me = this;
			var dt = this._getDoctype();
			var displayVal = val;

			// For title-link doctypes, find the label and display that instead
			if (isTitleLink(dt)) {
				for (var i = 0; i < this.items.length; i++) {
					if (this.items[i].value === val && this.items[i].label) {
						displayVal = this.items[i].label;
						break;
					}
				}
				// Update Frappe's title_value_map so get_input_value() returns the name
				if (ctrl.title_value_map) {
					ctrl.title_value_map[displayVal] = val;
				}
				// Cache title globally for Frappe
				if (frappe.utils.add_link_title) {
					frappe.utils.add_link_title(dt, val, displayVal);
				}
			}

			ctrl.$input.val(displayVal);

			function done() {
				ctrl.$input.trigger('change');
				ctrl.$input.blur();
				setTimeout(function () { me._justSelected = false; }, 100);
			}

			if (ctrl.parse_validate_and_set_in_model) {
				var p = ctrl.parse_validate_and_set_in_model(val);
				if (p && p.then) {
					p.then(done);
				} else {
					done();
				}
			} else if (ctrl.set_value) {
				ctrl.set_value(val);
				done();
			}
		},

		_createNew: function (doctype) {
			var ctrl = this.control;
			if (frappe.ui.form.quick_entry && frappe.model.can_create(doctype)) {
				frappe.new_doc(doctype, {}, function (doc) {
					if (doc && doc.name && ctrl) {
						ctrl.$input.val(doc.name);
						if (ctrl.parse_validate_and_set_in_model) {
							ctrl.parse_validate_and_set_in_model(doc.name);
						} else if (ctrl.set_value) {
							ctrl.set_value(doc.name);
						}
						ctrl.$input.trigger('change');
						frappe.link_cache.invalidate(doctype);
					}
				});
			} else {
				frappe.set_route('Form', doctype, 'new');
			}
		},

		_clearValue: function () {
			this.hide();
			var ctrl = this.control;
			if (ctrl) {
				ctrl.$input.val('');
				if (ctrl.parse_validate_and_set_in_model) {
					ctrl.parse_validate_and_set_in_model('');
				} else if (ctrl.set_value) {
					ctrl.set_value('');
				}
				ctrl.$input.trigger('change');
				ctrl.$input.blur();
			}
		},

		_showResults: function (results, txt) {
			this._renderItems(filterResults(results, txt || ''), txt || '');
			this.show();
		},

		_showLoading: function () {
			this.$el.html('<div class="instant-link-loading"><div class="ild-spinner"></div>Loading...</div>');
			this.show();
		},

		_renderItems: function (items, txt) {
			this.items = items;
			this.activeIndex = -1;
			var dt = this._getDoctype();
			var currentVal = this.$input.val();
			var html = '';

			if (currentVal && currentVal.trim()) {
				html += '<div class="instant-link-clear-row">'
					+ '<svg viewBox="0 0 12 12"><line x1="2" y1="2" x2="10" y2="10"/><line x1="10" y1="2" x2="2" y2="10"/></svg>'
					+ 'Clear</div>'
					+ '<div class="instant-link-separator"></div>';
			}

			if (!items.length) {
				html += '<div class="instant-link-empty">No results</div>';
			} else {
				var showTitle = isTitleLink(dt);
				for (var i = 0; i < items.length; i++) {
					var escaped = frappe.utils.escape_html(items[i].value || '');
					var label = items[i].label ? frappe.utils.escape_html(items[i].label) : '';
					var display = (showTitle && label) ? label : escaped;
					html += '<div class="instant-link-item" data-value="' + escaped + '">'
						+ '<span class="item-value">' + this._highlight(display, txt) + '</span>'
						+ '</div>';
				}
			}

			if (dt && frappe.model.can_create(dt)) {
				html += '<div class="instant-link-separator"></div>'
					+ '<div class="instant-link-create" data-doctype="' + frappe.utils.escape_html(dt) + '">'
					+ '<svg viewBox="0 0 16 16"><line x1="8" y1="3" x2="8" y2="13"/><line x1="3" y1="8" x2="13" y2="8"/></svg>'
					+ 'Create a new ' + frappe.utils.escape_html(dt) + '</div>';
			}

			this.$el.html(html);
		},

		_highlight: function (text, query) {
			if (!query) return text;
			var escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
			return text.replace(new RegExp('(' + escaped + ')', 'gi'), '<span class="match-highlight">$1</span>');
		},

		_serverSearch: function (dt, txt) {
			var me = this;
			var args = this._getQueryArgs();
			clearTimeout(this._serverTimer);
			// Abort any in-flight search XHR
			if (this._searchAbort && this._searchAbort.xhr) {
				try { this._searchAbort.xhr.abort(); } catch (e) {}
			}
			this._searchAbort = {};
			var abort = this._searchAbort;
			var loadStart = Date.now();
			this._serverTimer = setTimeout(function () {
				fetchLink(dt, txt, MAX_SHOW, abort, args.filters, args.query).then(function (results) {
					if (!me.$input.is(':focus') || !results.length) return;
					var remaining = Math.max(0, 350 - (Date.now() - loadStart));
					setTimeout(function () {
						if (me.$input.is(':focus')) {
							me._renderItems(results, txt);
							me.show();
						}
					}, remaining);
				});
			}, 150);
		},

		_getDoctype: function () {
			if (this.control && this.control.get_options) {
				return this.control.get_options();
			}
			return this.$input.attr('data-doctype') || '';
		},

		_getQueryArgs: function () {
			var result = { filters: null, query: null };
			var ctrl = this.control;
			if (!ctrl) return result;

			// df.link_filters — set on the Custom Field / Customize Form, stored as
			// [[doctype, fieldname, operator, value], ...]. The native control applies
			// these in set_custom_query(); this dropdown replaces that path, so they
			// have to be re-applied here or the field silently searches unfiltered.
			result.filters = this._parseLinkFilters(ctrl);

			// Check for get_query on the control instance or df
			var queryFn = ctrl.get_query || (ctrl.df && ctrl.df.get_query);
			if (!queryFn) return result;

			try {
				var args = typeof queryFn === 'function' ? queryFn(ctrl) : queryFn;
				if (!args) return result;

				// get_query can return { filters: {...} } or { query: "...", filters: {...} }
				// get_query wins over link_filters on a shared fieldname, matching
				// the merge order in frappe's set_custom_query().
				if (args.filters) result.filters = Object.assign(result.filters || {}, args.filters);
				if (args.query) result.query = args.query;
			} catch (e) {
				// Silently fail — fall back to unfiltered
			}
			return result;
		},

		// Mirrors frappe's ControlLink.parse_filters() (form/controls/link.js), including
		// its "eval:" support, so a field behaves the same whether the native dropdown
		// or this one is rendering it.
		_parseLinkFilters: function (ctrl) {
			var raw = ctrl.df && ctrl.df.link_filters;

			// List/report view standard filters are built from a fresh df in
			// base_list.js make_standard_filters(), which copies only a handful of
			// keys and drops link_filters — so the filter searches unfiltered while
			// the same field on the form is filtered. That df is stamped is_filter,
			// so read the real docfield back off the meta of the listed doctype.
			if (!raw && ctrl.df && ctrl.df.is_filter && window.cur_list && cur_list.doctype) {
				var meta_df = frappe.meta.get_docfield(cur_list.doctype, ctrl.df.fieldname);
				raw = meta_df && meta_df.link_filters;
			}

			if (!raw) return null;

			var parsed;
			try {
				parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
			} catch (e) {
				console.error('Invalid link_filters JSON:', raw, e);
				return null;
			}
			if (!parsed || !parsed.length) return null;

			var doc = ctrl.doc || (ctrl.frm && ctrl.frm.doc) || null;
			var filters = {};
			parsed.forEach(function (row) {
				// row is [doctype, fieldname, operator, value]
				var fieldname = row[1], operator = row[2], value = row[3];
				if (typeof value === 'string' && value.indexOf('eval:') === 0) {
					try {
						value = frappe.utils.eval(value.slice(5), {
							doc: doc,
							parent: doc && doc.parenttype && ctrl.frm ? ctrl.frm.doc : null,
							frappe: frappe,
						});
					} catch (e) {
						return; // drop the clause rather than filter on a bad value
					}
				}
				filters[fieldname] = [operator, value];
			});

			return Object.keys(filters).length ? filters : null;
		},

		_hasFilters: function () {
			var args = this._getQueryArgs();
			return !!(args.query || (args.filters && Object.keys(args.filters).length));
		},

		_cacheKey: function () {
			var dt = this._getDoctype();
			var args = this._getQueryArgs();
			if (!args.filters && !args.query) return dt;
			return dt + '::' + JSON.stringify(args);
		},

		show: function () {
			this._position();
			this.$el.addClass('show');
			this._visible = true;
		},

		hide: function () {
			this.$el.removeClass('show');
			this._visible = false;
			this.activeIndex = -1;
			this._mouseDownOnDropdown = false;
		},

		_position: function () {
			var offset = this.$input.offset();
			var inputH = this.$input.outerHeight();
			var inputW = this.$input.outerWidth();
			var dropH  = this.$el.outerHeight();
			var winH   = $(window).height();
			var scrollTop = $(window).scrollTop();

			var spaceBelow = winH + scrollTop - (offset.top + inputH);
			var top = (spaceBelow < dropH + 10 && offset.top - scrollTop > dropH)
				? offset.top - dropH - 2
				: offset.top + inputH + 2;

			this.$el.css({
				top: top,
				left: offset.left,
				minWidth: inputW,
				maxWidth: Math.max(inputW + 100, 350),
			});
		},

		destroy: function () {
			this.$input.off('.ild');
			this.$el.remove();
			$(document).off('.ild_' + this._uid());
			$(window).off('.ild_' + this._uid());
			clearTimeout(this._serverTimer);
			if (this._searchAbort && this._searchAbort.xhr) {
				try { this._searchAbort.xhr.abort(); } catch (e) {}
			}
		},
	};

	// -------------------------------------------------------
	// Patch ControlLink
	// -------------------------------------------------------
	function patchControlLink() {
		var CL = frappe.ui.form.ControlLink;
		if (!CL || !CL.prototype) return false;

		var _origMakeInput = CL.prototype.make_input;

		CL.prototype.make_input = function () {
			_origMakeInput.apply(this, arguments);
			if (!this.$input) return;

			if (this.awesomplete) {
				try { this.awesomplete.destroy(); } catch (e) {}
				this.awesomplete = null;
			}

			var $awWrap = this.$input.closest('.awesomplete');
			if ($awWrap.length && $awWrap[0] !== this.$input[0]) {
				$awWrap.replaceWith(this.$input);
			}

			this.$input.off('input.link_field keypress.link_field awesomplete-selectcomplete awesomplete-open awesomplete-close blur');
			this._ild_patched = true;

			if (this._instantDropdown) this._instantDropdown.destroy();
			this._instantDropdown = new LinkDropdown(this.$input, this);
		};

		var _origSetupAC = CL.prototype.setup_awesomplete;
		CL.prototype.setup_awesomplete = function () {
			if (this._ild_patched) return;
			return _origSetupAC.apply(this, arguments);
		};

		return true;
	}

	// -------------------------------------------------------
	// Prefetch form links (deduplicated — only on form refresh, not page-change)
	// -------------------------------------------------------
	function prefetchFormLinks() {
		if (!cur_frm || !cur_frm.fields) return;
		var doctypes = {};
		cur_frm.fields.forEach(function (f) {
			if (f.df && f.df.fieldtype === 'Link' && f.df.options) {
				doctypes[f.df.options] = 1;
			}
		});
		Object.values(cur_frm.fields_dict || {}).forEach(function (field) {
			if (field.grid) {
				var meta = frappe.get_meta(field.df.options);
				if (meta && meta.fields) {
					meta.fields.forEach(function (df) {
						if (df.fieldtype === 'Link' && df.options) {
							doctypes[df.options] = 1;
						}
					});
				}
			}
		});
		Object.keys(doctypes).forEach(function (dt) { prefetch(dt); });
	}

	// Only prefetch on form refresh (not page-change — avoids double-fire)
	if (frappe.ui.form.Form) {
		var _origRefresh = frappe.ui.form.Form.prototype.refresh;
		frappe.ui.form.Form.prototype.refresh = function () {
			var r = _origRefresh.apply(this, arguments);
			prefetchFormLinks();
			return r;
		};
	}

	// Cache invalidation
	frappe.link_cache = {
		invalidate: function (dt) { delete _store[dt]; prefetch(dt); },
		invalidateAll: function () { Object.keys(_store).forEach(function (k) { delete _store[k]; }); },
		stats: function () { return { cached: Object.keys(_store), count: Object.keys(_store).length }; },
	};

	if (frappe.ui.form.Form) {
		var _origSave = frappe.ui.form.Form.prototype.after_save;
		frappe.ui.form.Form.prototype.after_save = function () {
			frappe.link_cache.invalidate(this.doctype);
			return _origSave.apply(this, arguments);
		};
	}

	// Init — inject styles once, patch ControlLink
	injectAllStyles();
	if (!patchControlLink()) {
		var _t = setInterval(function () {
			if (patchControlLink()) clearInterval(_t);
		}, 50);
	}

	console.log('[Instant Link] Custom dropdown active');
})();
